import React, {Component} from "react"
import PropTypes from "prop-types"
import {Col} from "react-bootstrap"
import styled from "styled-components"
import {FormattedMessage} from "react-intl"

import id from "@irati/utils/id"
import {READY_TO_LAUNCH} from "@irati/insights/constants/schedule"

import Table, {Tr} from "../../../ui/SimpleTable"
import padding from "../../../../../ui/src/global/padding"
import Tick from "../../../../images/icons/tick.svg"
import {SendExampleSurveyContainer} from "../../Schedule/Actions"
import DateValidator from "./DateValidator"
import TeamsValidator from "./TeamsValidator"
import NameValidator from "./NameValidator"
import FrequencyRenderer from "../../Schedule/Renderers/FrequencyRenderer"

import Title from "./Title"
import {ParaNoMargin, Td} from "./ui/layout"
import GoToHomepage from "./GoToHomepage"
import isCycleCustom from "../../../helpers/cycle/isCycleCustom"
import QuestionCountValidator from "./QuestionCountValidator"

const Container = styled(Col)`
  background-color: white;
  padding: ${padding.medium};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const StyledTable = styled(Table)`
  flex: 1;
  max-width: 450px;
  text-align: left;
  margin-top: ${padding.small};
`

const Footer = styled.div`
  margin-top: ${padding.small};
  max-width: 500px;
  text-align: center;
`

class Validate extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    backToRoute: PropTypes.string.isRequired
  }

  render() {
    const idNamespace = id("Validate", this.props)
    const {schedule, backToRoute} = this.props
    const {
      emails: {
        userReminder: {afterDays}
      }
    } = schedule.preferences
    const {validationStatus, reference} = schedule
    const isReadyToLaunch = validationStatus === READY_TO_LAUNCH
    schedule.runOnce = isCycleCustom(schedule)

    return (
      <Container id={idNamespace} xs={10} xsOffset={1}>
        <img src={Tick} alt="" />
        <Title schedule={schedule} />
        <StyledTable>
          <Tr>
            <Td isLeft>
              <ParaNoMargin bold>
                <FormattedMessage id="insights.schedule.validate.reference.label" />
              </ParaNoMargin>
            </Td>
            <Td>
              <ParaNoMargin>{reference}</ParaNoMargin>
            </Td>
          </Tr>

          <DateValidator schedule={schedule} backToRoute={backToRoute} />

          {!schedule.runOnce && <FrequencyRenderer schedule={schedule} />}

          <QuestionCountValidator schedule={schedule} backToRoute={backToRoute} />

          <TeamsValidator id={idNamespace} schedule={schedule} backToRoute={backToRoute} />

          <Tr>
            <Td isLeft>
              <ParaNoMargin bold>
                <FormattedMessage id="insights.schedule.validate.reminderEmail.label" />
              </ParaNoMargin>
            </Td>
            <Td>
              <ParaNoMargin>
                {afterDays ? (
                  <FormattedMessage id="insights.schedule.validate.reminderEmail.onLabel" />
                ) : (
                  <FormattedMessage id="insights.schedule.validate.reminderEmail.offLabel" />
                )}
              </ParaNoMargin>
            </Td>
          </Tr>

          <NameValidator schedule={schedule} backToRoute={backToRoute} />
        </StyledTable>

        <SendExampleSurveyContainer schedule={schedule} />

        {isReadyToLaunch && <GoToHomepage />}

        <Footer>
          {" "}
          <FormattedMessage id="insights.wizard.step3.footerDescription" />{" "}
        </Footer>
      </Container>
    )
  }
}

export default Validate
